import React from 'react';
import { BatteryLowIcon, CompassIcon, FolderOpenIcon, HourglassIcon, ListTodoIcon, ShuffleIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { pains } from '../../data/lists';
const icons = [ShuffleIcon, HourglassIcon, CompassIcon, FolderOpenIcon, BatteryLowIcon, ListTodoIcon];
export function Pains() {
  return <section className="bg-paper px-4 py-16 sm:py-20" data-id="element-279" data-mp="316t4ciowzlqo">
      <div className="mx-auto max-w-5xl" data-id="element-280" data-mp="3158akvafc6tv">
        <SectionHeading title="Do any of these sound familiar?" sub="If you answer YES to any of these, I created this method for you." data-id="element-281" data-mp="2w8rlnyvehofq" />

        <ul className="mt-10 grid gap-3 md:grid-cols-2" data-id="element-282" data-mp="3ayywptj2w56e">
          {pains.map((p, i) => {
          const Icon = icons[i];
          return <li key={p} className="flex items-start gap-4 rounded-2xl bg-cream p-4 sm:p-5" data-id="element-283" data-mp="3jyub077xkgan" data-mpi={i}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-blush text-rose" data-id="element-284" data-mp="3fx8rw44sz5s0">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-285" data-mp="j18avp7u3fk3" />
                </span>
                <p className="text-base leading-relaxed text-ink" data-id="element-286" data-mp="n20lomwctsih">{p}</p>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-12 max-w-2xl space-y-4 text-center text-lg leading-relaxed text-ink" data-id="element-287" data-mp="s2evoahincj5">
          <p className="font-serif text-2xl font-bold text-forest" data-id="element-288" data-mp="wxc4phesplw1">And it doesn't have to stay this way.</p>
          <p className="text-muted" data-id="element-289" data-mp="11wox0hofrl60">
            Because after years of studying and working with reflexology, I've learned something that I believe is incredibly
            important:
          </p>
          <p className="rounded-2xl border-l-4 border-cta bg-cream px-5 py-4 text-left font-serif text-xl font-semibold italic" data-id="element-290" data-mp="1at63h7luuuvf">
            More information doesn't automatically create better practice.
          </p>
          <p data-id="element-291" data-mp="1pnucuwudmdgb">You need a structure that helps you actually use what you're learning. That's why I created this method.</p>
        </div>

        <div className="mt-10" data-id="element-292" data-mp="100qaqagq7vnf">
          <CTAButton label="Yes! Give me a clear reflexology practice system" note="Instant access · 7-Day Guarantee" data-id="element-293" data-mp="zxueqrofvh1m" />
        </div>
      </div>
    </section>;
}